import { BaseScheduleDayComment } from '../../../@paco/entities/BaseSchedule/BaseSchedule'
import { getDayNumberFromDate } from '../../../@paco/helpers/date'

export const getCycleDayNumber = (weekIndex: number, date: Date): number => (
    weekIndex * 7 + getDayNumberFromDate(date)
)

export const getBaseScheduleCommentsForWeek = (
    comments: BaseScheduleDayComment[],
    weekIndex: number,
): BaseScheduleDayComment[] => comments
    .filter(comment => comment.dayNumber > weekIndex * 7 && comment.dayNumber <= (weekIndex + 1) * 7)
    .map(comment => ({
        ...comment,
        dayNumber: comment.dayNumber - weekIndex * 7,
    }))
